import { TagOption } from 'components/shared/Tags/model';
import { TagBadge } from 'components/shared/underlyings/selector/multi/tag-badge';
import { Underlying } from 'models/underlying';
import { components, SingleValueProps } from 'react-select';

type Props = Omit<SingleValueProps<TagOption<Underlying>, false>, 'children' | 'data'> & {
  data: TagOption<Underlying>;
  canHighlight?: boolean;
  onTagHighlightToggled?: (labelToToggle: string) => void;
  onTagRemoved: (labelToRemove: string) => void;
};
export function SingleValue({ data, canHighlight, onTagHighlightToggled, onTagRemoved, ...props }: Props) {
  return (
    <components.SingleValue data={data} {...props}>
      <TagBadge
        className="pe-2"
        key={data.label}
        value={data.rawValue}
        isDisabled={data.isDisabled ?? false}
        isHighlighted={data.isHighlighted ?? false}
        label={data.label}
        canHighlight={canHighlight}
        onTagHighlightToggled={onTagHighlightToggled}
        onTagRemoved={onTagRemoved}
      />
    </components.SingleValue>
  );
}
